export function prevScroll(category) {
    return { type: 'ARP_PREV_SCROLL', payload: category };
}

export function nextScroll(category) {
    return { type: 'ARP_NEXT_SCROLL', payload: category };
}